import type { ReactNode } from 'react';

export const symbol_run_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m525-385-53-58-16 81q-2 12-13 19t-23 5l-96-20q-6-2-9.5-6.5T313-375q2-6 7-10t11-2l96 20 42-210-74 28v49q0 6-4.5 10.5T380-485q-6 0-10.5-4.5T365-500v-50q0-10 5.5-17.5T385-578l108-39q14-5 26-.5t18 18.5q19 39 42 57.5t41 23.5q6 2 10.5 6.5T635-500q0 6-4.5 10t-10.5 2q-21-6-48-24t-51-50l-19 108 45 48q4 5 6 10t2 11v125q0 6-4.5 10.5T540-245q-6 0-10.5-4.5T525-260v-125Zm5-255q-12 0-21-9t-9-21q0-13 9-21.5t21-8.5q13 0 21.5 8.5T560-670q0 12-8.5 21t-21.5 9ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Z"
		/>
	</svg>
);
